import React from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import {
  white,
  gray80,
  gray40,
  secondaryButtonBackgroundColor,
  tertiaryButtonBackgroundColor,
} from '../../constants/colors';
import { useNavigate } from 'react-router-dom';

const styles = {
  paper: {
    padding: '40px 40px',
    maxWidth: '398px',
    width: '100%',
    backgroundColor: white,
    border: `1px solid ${gray40}`,
    textAlign: 'center',
    '@media (max-width: 600px)': {
      margin: '0 16px',
    },
  },
  icon: {
    fontSize: '56px',
    color: gray80,
    marginBottom: '24px',
  },
  button: {
    marginTop: '30px',
    fontWeight: '700',
  },
  beforeNextButton: {
    marginTop: '16px',
    width: '100%',
  },
  titleText: {
    fontSize: '22px',
    fontWeight: '400',
    marginBottom: '10px',
    whiteSpace: 'pre-wrap',
  },
  messageText: {
    textAlign: 'left',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
  },
  messageTextCenter: {
    textAlign: 'center',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
  },
};

interface CompleteProps {
  IconComponent: SvgIconComponent;
  titleText: string;
  isMessageCenter?: boolean;
  messageText: string;
  buttonText: string;
  targetPath: string;
  secondaryLeftButtonText?: string;
  secondaryLeftPath?: {
    path: string;
    state?: { [key: string]: string | number | boolean | null };
  } | null;
  secondaryRightButtonText?: string;
  secondaryRightPath?: {
    path: string;
    state: { [key: string]: string | number | boolean | null };
  } | null;
}

const MypageCompleteCard: React.FC<CompleteProps> = ({
  IconComponent,
  titleText,
  isMessageCenter,
  messageText,
  buttonText,
  targetPath,
  secondaryLeftButtonText,
  secondaryLeftPath,
  secondaryRightButtonText,
  secondaryRightPath,
}) => {
  const navigate = useNavigate();
  const hasThreeButtons = secondaryLeftButtonText && secondaryLeftPath;

  return (
    <>
      <Paper elevation={0} sx={styles.paper}>
        <IconComponent sx={styles.icon} />
        <Typography variant="body2" gutterBottom sx={styles.titleText}>
          {titleText}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={isMessageCenter ? styles.messageTextCenter : styles.messageText}
        >
          {messageText}
        </Typography>
        <Button
          onClick={(): void => {
            navigate(targetPath);
          }}
          fullWidth
          variant="outlined"
          sx={[
            hasThreeButtons ? tertiaryButtonBackgroundColor : secondaryButtonBackgroundColor,
            styles.button,
          ]}
        >
          {buttonText}
        </Button>
        {(secondaryLeftButtonText && secondaryLeftPath) ||
        (secondaryRightButtonText && secondaryRightPath) ? (
          <Box sx={{ display: 'flex', gap: '16px' }}>
            {secondaryLeftButtonText && secondaryLeftPath && (
              <Button
                onClick={(): void => {
                  navigate(secondaryLeftPath.path, { state: secondaryLeftPath.state });
                }}
                variant="outlined"
                sx={[secondaryButtonBackgroundColor, styles.beforeNextButton]}
              >
                {secondaryLeftButtonText}
              </Button>
            )}
            {secondaryRightButtonText && secondaryRightPath && (
              <Button
                onClick={(): void => {
                  navigate(secondaryRightPath.path, { state: secondaryRightPath.state });
                }}
                variant="outlined"
                sx={[secondaryButtonBackgroundColor, styles.beforeNextButton]}
              >
                {secondaryRightButtonText}
              </Button>
            )}
          </Box>
        ) : null}
      </Paper>
    </>
  );
};

export default MypageCompleteCard;
